<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Button from '@mobile/components/Button/Button.vue'
import * as popup from '@mobile/globalState/popup'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'

import { DecisionReviewPopup } from '../Popups/DecisionReview/DecisionReviewPopup'

export default defineComponent({
  components: { Button },
  props: {
    context: {
      type: Object as PropType<PopupContext | null>,
      required: false,
    },
  },
  setup(props) {
    function handleClick(): void {
      if (props.context) {
        props.context?.openPopup(DecisionReviewPopup)
      } else {
        popup.show({
          component: DecisionReviewPopup,
          showHeader: true,
        })
      }
    }

    return { handleClick }
  },
})
</script>

<template>
  <Button
    :size="'sm'"
    :color="'white'"
    :withIcon="false"
    :type="'horizontal'"
    @click="handleClick"
  >
    Decision review
  </Button>
</template>
